<template>
	<div class="page machines">
		<section id="navigation">
			<div class="container">
				<div class="content flex">
					<span @click="$router.go(-1);" class="go-back"><svg class="navigation-icon link-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20"><path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z"/></svg></span>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="navigation-icon self"><path d="M10 18h5v-6h-5v6zm-6 0h5V5H4v13zm12 0h5v-6h-5v6zM10 5v6h11V5H10z"></path></svg>
					<span class="navigation-title">{{$t('machines')}}</span>
				</div>
			</div>
		</section>
		<transition name="slide-up" mode="out-in" appear>
			<section class="main no-padding-top">
				<FilteredSearch :loaded="machinesLoaded" :list="machines" :click="machineClick" :customText="customerText" :placeholder="$t('search')" :filterAttributes="filterAttributes"/>
			</section>
		</transition>
	</div>
</template>

<script>
import FilteredSearch from '@/components/FilteredSearch.vue'

export default {
	data() {
		return {
			machines: [],
			machinesLoaded: false,
			filterAttributes: [
				{attribute: 'name', text: this.$t('name')},
				{attribute: 'code', text: this.$t('code')},
				{attribute: 'machine_type_name', text: this.$t('machine-type')},
				{attribute: 'serial_number', text: this.$t('serial-number')},
				{attribute: 'spindles_number', text: this.$t('spindles-number')},
			],
		}
	},
	computed: {
		username() {
			return this.$store.getters.getProfile.name;
		},
		id() {
			return this.$store.getters.getProfile.id;
		}
	},
	methods: {
		machineClick(item) {
			let target = this.$route.query.target || 'machine';
			this.$router.push({name: target, params: {id: item.id}});
		},
		customerText(item) {
			return `${item.name}`
		},
	},
	components: {
		FilteredSearch
	},
	created() {
		let self = this;
		axios.get(`/customers/${self.id}/machines`)
		.then((response) => {
			self.machines = [...response.data.response.machines];
			self.machinesLoaded = true;
		})
		.catch((err) => {
			self.$router.go(-1);
		});
	},
}
</script>

<style scoped>
</style>